import ErrorModalComponent from 'dialogs/GenericDialogModals/ErrorModal';
import store, { dispatch } from 'src/redux/config/configureStore';
import { openDialog } from 'src/redux/slices/dialogs.slice';
import { addErrorToQueue } from 'src/redux/slices/general.slice';
import { DialogType } from 'src/redux/types/redux.types';
import { i18nService } from 'src/services/i18n.service';
import { SavingError } from 'src/types';

export const handleError = (err): SavingError => {
  const errorCode =
    err?.response?.data?.status_code ||
    err?.response?.data?.statusCode ||
    err?.response?.status ||
    500;
  const errorMsg = err?.response?.data?.message;
  const savingError: SavingError = { errorCode, description: errorMsg, err };
  showErrorModal(errorCode);
  return savingError;
};

export const handleErrorGraphql = (err): any => {
  const errorCode = err?.response?.status || 500;
  const errorMsg = err?.response?.errors?.length
    ? err.response.errors.map(x => x.message).join('\n')
    : '';
  const data = err?.response?.data;
  const savingError: SavingError = {
    errorCode,
    description: errorMsg,
    err,
  };
  if (data) {
    savingError.data = data;
  }
  if (err?.response?.errors?.length && !isForbidden200Error(err) && !isUnauthorized200Error(err)) {
    showErrorModal(err?.response?.status, errorMsg);
  }
  return savingError;
};

//Returns whether this is a success call of a forbidden resources
//Used for an unknown user in the investor data fetch or Currency rates fetch
function isForbidden200Error(err) {
  const isForbidden = err?.response?.errors[0]?.message === 'Forbidden resource';
  return err?.response?.status === 200 && isForbidden;
}

//Returns whether this is a success call of a forbidden resources
//Used for an unknown user in the investor data fetch or Currency rates fetch
function isUnauthorized200Error(err) {
  const isUnauthorized = err?.response?.errors[0]?.message === 'Unauthorized';
  return err?.response?.status === 200 && isUnauthorized;
}

export const showErrorModal = (status, errorText?, errorTitle?) => {
  // Add the error to the queue
  dispatch(addErrorToQueue({ errorStatus: status, errorText, errorTitle }));

  // If there's already a dialog open, don't open another one
  const { dialogs } = store.getState().dialogs;
  if (dialogs?.length > 0) {
    return;
  }

  dispatch(
    openDialog({
      type: DialogType.Alert,
      header:
        errorTitle ||
        i18nService.translate('errors.api.alert.title', {
          status: status,
        }),
      content: <ErrorModalComponent />,
    }),
  );
};
